import { render, staticRenderFns } from "./RecordListScreen.vue?vue&type=template&id=4929c6ce&"
import script from "./RecordListScreen.vue?vue&type=script&lang=js&"
export * from "./RecordListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports